<template>
	<div style="background-color: #2c68ff;">
		<div style="width: 1200px;margin: 0 auto;">
			<el-menu class="el-menu-demo" mode="horizontal"
				background-color="#2c68ff" text-color="#fff" active-text-color="#fff" router
				style="height:52px !important;">
				<el-menu-item index="/irpi" class="navBarList">首页</el-menu-item>
				<el-menu-item index="/structure" class="navBarList">组织架构</el-menu-item>
				<el-menu-item index="/expert" class="navBarList">专家简介</el-menu-item>
				<el-menu-item index="/finance" class="navBarList">金融服务</el-menu-item>
				<el-menu-item index="/intellectualProperty" class="navBarList">知识产权托管</el-menu-item>
				<el-menu-item index="/patentNav" class="navBarList">专利导航</el-menu-item>
				<el-menu-item index="/personnel" class="navBarList">人才培养</el-menu-item>
				<el-menu-item index="/news" class="navBarList">行业资讯</el-menu-item>
				<el-menu-item index="/contactUs" class="navBarList">联系我们</el-menu-item>
			</el-menu>
		</div>
	</div>
</template>

<script>
	import {
		ref,
	} from 'vue'
	export default{
		setup() {
			// 导航菜单
			const activeIndex = ref('1')
			return {
				activeIndex
			}
		},
	}
</script>

<style scoped>
	.el-icon svg{
		display: none !important;
	}
	.navBarList{
		margin-right:30px !important;
		font-size: 16px;
	}
</style>
